@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

$var-shadow: 0 1px 4px 0 Colors.$col-shadow;

.section {
	background-color: white;
	margin: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-m;
	max-width: Constants.$val-maxBoxSize;
	margin: 0 auto;
	box-shadow: $var-shadow;
	border: 1px solid Colors.$col-shadow;
}

.section-title {
	color: Colors.$col-greyFontLight;
	padding-bottom: Constants.$val-spacing-s;
	text-transform: uppercase;
	font-size: Constants.$val-fontSizeBig;
}
